<template>
    <div class="wrapper">
        <dots id="dots"></dots>
        <h3 v-if="getInstructions !== undefined">{{getInstructions}}</h3>
        <div class="decision" v-for="(d, i) in decisions" :key="'d_' + i">
            <h1 class="action-title" id="action-title">{{d.name}}</h1>
            <div v-html="d.description" :class="d.type" class="action-description"></div>

            <div class="options-group" :class="{ maxed: maxed }">
                <div
                    class="option"
                    :class="{ 'sel' : currentActionSelections( i, j ) }"
                    v-for="(o, j) in d.options"
                    :key="'o_' + j"
                    @click="toggleSelection( { i, j } )">
                        <div class="option-select" >
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                                <circle id="circle" cx="12" cy="12" r="12"/>
                                <polyline  id="check" fill="none" stroke-width="2" stroke-miterlimit="10" points="6.458,11.552 10.356,15.449 17.542,8.551 "/>
                            </svg>
                        </div>
                        <div class="option-details noselect">
                            {{o.question}}
                        </div>
                </div>
            </div>
        </div>
        <div class="sticky-footer">
            <button :disabled='!maxed' class="btn center noselect" @click="animateOut">Submit Decisions</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Dots from '../components/Dots.vue';
    import { gsap } from '/src/assets/js/gsap';
    
    export default {
        components: { Dots },
        name : "InvestigationItem",
        methods : {
            ...mapActions([
                'toggleSelection',
                'submitAction'
            ]),
            completeDecision(){
                this.submitAction()
                this.$router.push( { path : this.feedbackPath } )
            },
            animateOut() {
                gsap.to('#dots, h1, .action-description, .option, button', {autoAlpha: 0, stagger: { amount: 0.35}, ease: "sine.in"});
                gsap.delayedCall(1, this.completeDecision);
            }
        },
        computed : {
            ...mapGetters([
                "getInstructions",
                "currentActionSelections",
                'getDecisionsBySlug',
                'getSelected',
                'areSelectionsMaxed'
            ]),
            decisions(){
                const slug = this.getDecisionsBySlug( this.$router.currentRoute.params.action )
                return slug
            },
            maxed(){
                return this.decisions.map( ( d, i ) => {
                    return this.areSelectionsMaxed( i )
                }).reduce( ( a, c ) => a && c )
            },
            feedbackPath(){
                const p = this.$router.currentRoute
                return "/sim/" + p.params.action + "/feedback"
            }
        },
        mounted () {
            // animate in
            gsap.from('#dots, h1, .action-description, .option', { autoAlpha: 0, stagger: { amount: 0.5 }, ease: 'back.out'})
        }
    }
</script>